export interface IGDPRFilesResources {
    title: string;
    description: string;
    downloadButton: string;
    fileSize: string;
    fileDate: string;
}

export const GDPRFilesResources: IGDPRFilesResources = {
    title: "RODO - kopia danych",
    description:
        "Poniżej znajdziesz plik z danymi, o które prosiłeś w ramach procedur związanych z RODO",
    downloadButton: "POBIERZ PLIK {0}",
    fileSize: "Rozmiar pliku: {0}",
    fileDate: "Data utworzenia pliku: {0}",
};
